import { Box, PageFooter } from '@wix/design-system';
import {
  CycleUtils,
  getSearchParams,
  GtmEvents,
  useGtmLogger,
} from '@wix/package-picker-shared';
import {
  Checkout,
  useCurrentModule,
  EclipsePackagePickerSteps,
  Faq,
  NonBlockerWrapper,
  TrustBuilders,
  useInitLayoutBiEvents,
  useInitCheckoutPageBiEvents,
  PageDisclaimer,
} from '@wix/package-picker-shared-eclipse';
import React from 'react';
import { AllPlansIncludedFeaturesBanner } from '../../components/AllPlansIncludedFeaturesBanner';
import { HeaderBanner } from '../../components/HeaderBanner';
import { NavigateBack } from '../../components/NavigateBack';
import { PageTitle } from '../../components/PageTitle';

export const CheckoutPage = () => {
  const module = useCurrentModule();
  const { t } = module.internals.useTranslations();
  const changeRoute = module.internals.hooks.useChangeRoute();
  const { experiments } = module.internals.experiments.hooks.useExperiments();
  const isCheckoutWithoutFaqEnabled = experiments.isEnabled(
    'checkoutWithoutFaq',
  );
  const isCheckoutWithoutTrustBuildersEnabled = experiments.isEnabled(
    'checkoutWithoutTrustBuilders',
  );
  useGtmLogger(GtmEvents.CHECKOUT);
  useInitCheckoutPageBiEvents();
  useInitLayoutBiEvents();

  // Sync productId & cycleId from URL query params into store
  React.useEffect(() => {
    const { productId, cycleId } = getSearchParams();
    if (productId) {
      module.SDK.PackagePickerStore.setSelectedProductId(productId);
    }
    if (cycleId) {
      module.SDK.PackagePickerStore.setSelectedCycleId(
        CycleUtils.validateCycleId(cycleId),
      );
    }
  }, []);

  const handleBack = () => {
    module.internals.bi.onBackButtonClick?.({
      fromStep: EclipsePackagePickerSteps.CHECKOUT,
    });
    changeRoute(EclipsePackagePickerSteps.SELECT_CYCLE);
  };

  return (
    <Box
      direction="vertical"
      width="100%"
      align="center"
      paddingBottom="SP6"
      boxSizing="border-box"
    >
      <HeaderBanner />
      <Box
        margin="0 auto"
        direction="vertical"
        width="100%"
        align="center"
        padding="0px SP6"
        boxSizing="border-box"
      >
        <Box width="100%" direction="horizontal" verticalAlign="middle">
          <NavigateBack
            onBack={handleBack}
            backButtonText={t('premium-purchase-plan.eclipse.back.cta')}
          />
          <PageTitle />
        </Box>
        <Box width="100%" marginTop="SP3">
          <NonBlockerWrapper componentName="AllPlansIncludedFeaturesBanner">
            <AllPlansIncludedFeaturesBanner />
          </NonBlockerWrapper>
        </Box>
        <Box width="100%" align="center" direction="vertical">
          <Box marginTop="SP7" direction="vertical">
            <Checkout shouldOpenDoublePurchaseModal />
            <PageDisclaimer />
          </Box>
        </Box>
        {!isCheckoutWithoutTrustBuildersEnabled && (
          <Box width="100%" align="center" marginTop="SP10">
            <TrustBuilders />
          </Box>
        )}
        {!isCheckoutWithoutFaqEnabled && (
          <Box marginTop="78px" width="100%">
            <NonBlockerWrapper componentName="Faq">
              <Faq />
            </NonBlockerWrapper>
          </Box>
        )}
        <PageFooter />
      </Box>
    </Box>
  );
};
